module.exports = __webpack_public_path__ + "img/fork-and-knife.ec68bb5d.svg";